@use "~@optimizely/design-tokens/dist/scss/colors";

:host {
  display: block;
}

.product-switcher {
  display: inline-flex;
  background: #080736;
  height: 40px;
  vertical-align: middle;
}

.divider {
  display: flex;
  color: colors.$brand-blue-base;
  width: var(--axiom-space-large);
  justify-content: center;
  height: 100%;
  align-items: center;
}

.error {
  display: flex;
  align-items: center;
  height: 100%;
  &__message {
    border: 1px solid #f33030;
    border-radius: 5px;
    padding: 4px;
    background-color: #feecec;
    color: #080736;
    margin-left: 12px;
  }
}

.org,
.product {
  max-width: 500px;
}
